import { useContext, useMemo } from 'react';
import { AccountContext } from 'context/account';
import { useCart } from 'frontastic';
import { GlobalAnalyticsContext } from './types';

export const useGlobalContext = (): GlobalAnalyticsContext => {
  const { account, loggedIn, accountLoading } = useContext(AccountContext);
  const { data: cart } = useCart();

  return useMemo(() => {
    const getLoginState = () => {
      if (accountLoading) return 'guest';
      return loggedIn && account?.accountId ? 'logged_in' : 'logged_out';
    };

    return {
      ecomm_customer_id: account?.accountId,
      user_hashed_email: account?.hashedEmail,
      login_state: getLoginState(),
      cart_id: cart?.cartId,
    };
  }, [account?.accountId, account?.hashedEmail, loggedIn, accountLoading, cart?.cartId]);
};
